/*
 * @Description:
 * @Author: Leyton
 * @LastEditors: Leyton
 * @LastEditTime: 2022-07-21 21:58:55
 * @FilePath: /91qs_answer_frontpro/src/pages/questionnaire/js/countdown.js
 */
import React, { useState, useEffect, useRef } from "react";

const Countdown = ({
  countdown,
  themeColor,
  className,
  btnText,
  onClick,
  ...others
}) => {
  const [time, setTime] = useState(countdown);
  const countRef = useRef(countdown);
  let flag = null;
  if (others.questions) {
    try {
      flag = others.questions[0].code;
    } catch (error) {}
  }

  useEffect(() => {
    countRef.current = countdown;
    let timer = null;
    const innerFun = () => {
      timer = setTimeout(() => {
        if (countRef.current >= 1) {
          countRef.current--;
          setTime(countRef.current);
          innerFun();
          return;
        }
        return setTime(0);
      }, 1000);
    };
    innerFun();
    return () => clearTimeout(timer);
  }, [countdown, flag]);

  return (
    <div
      className="page-button"
      style={{ background: countRef.current > 0 ? "#898988" : themeColor }}
      {...others}
      onClick={time > 0 ? () => {} : onClick}
    >
      {countRef.current > 0 ? `${countRef.current}s` : btnText}
    </div>
  );
};

export default Countdown;
